'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var ItemCardClaims = require('../../components/ItemCardClaims.js');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var ItemSelectionCardActions = require('./ItemSelectionCardActions.js');
var IneligibleReasonChip = require('../../components/IneligibleReasonChip.js');
var RemoveItemButton = require('../../components/RemoveItemButton.js');
var ItemSelectionProvider = require('./ItemSelectionProvider.js');
var ItemSelectionItemIneligibleReason = require('./ItemSelectionItemIneligibleReason.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ItemSelectionItemCardClaims = _ref => {
  let {
    item,
    itemDetails,
    packageId,
    ...rest
  } = _ref;
  const {
    handleRemove,
    itemClaims
  } = ItemSelectionProvider.useItemSelection();
  const {
    claimsSelectionRemoveSelection
  } = nthHookTranslations.useTranslations();
  const claimDetails = itemClaims[`${item.itemRefId}_${packageId}`];
  const isSelected = Boolean(claimDetails);
  const {
    ineligibilityReason
  } = itemDetails.evaluatedEligibility;
  return /*#__PURE__*/React__default["default"].createElement(ItemCardClaims["default"], _extends__default["default"]({
    itemDetails: itemDetails,
    claimDetails: claimDetails,
    layout: "horizontal",
    additionalDetails: /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, isSelected && /*#__PURE__*/React__default["default"].createElement(ItemSelectionCardActions["default"], {
      claimDetails: claimDetails,
      packageId: packageId
    }), ineligibilityReason && /*#__PURE__*/React__default["default"].createElement(IneligibleReasonChip["default"], null, /*#__PURE__*/React__default["default"].createElement(ItemSelectionItemIneligibleReason["default"], {
      item: item,
      packageId: packageId
    })), isSelected && /*#__PURE__*/React__default["default"].createElement(RemoveItemButton["default"], {
      onClick: () => handleRemove({
        itemUid: item.itemRefId,
        packageId
      })
    }, claimsSelectionRemoveSelection))
  }, rest));
};
var ItemSelectionItemCardClaims$1 = nthHookTranslations.withTranslationsProvider(ItemSelectionItemCardClaims, {
  translationKeys: ['claimsSelectionRemoveSelection']
});

exports["default"] = ItemSelectionItemCardClaims$1;
